import FieldsInvoiceTax from './FieldsInvoiceTax'

export default FieldsInvoiceTax
